import UserSettingsViewsMyWork from "./my-work";


export default class UserSettingsViewsMyWork_Collection {

    public models   : UserSettingsViewsMyWork[]
    protected byId  : {[key:ID]: UserSettingsViewsMyWork}  = {}

    // Legacy settings saved before my work views became per company.
    // Used as defaults for every company by syncCompanies().
    protected defaults : JSONObject = {}

    constructor(models: UserSettingsViewsMyWork[]) {
        this.models = models
    }

    static initFromJson(data: JSONObject | JSONArray) {
        const collection = new UserSettingsViewsMyWork_Collection([])

        if (Array.isArray(data)) {
            _.map(data, (item: JSONObject)=> {
                collection.add(new UserSettingsViewsMyWork(item))
            })
        } else {
            // Companies are not loaded when settings are parsed (me event comes
            // before companies reset), models are created by syncCompanies().
            collection.defaults = data || {}
        }

        return collection
    }

    add(model: UserSettingsViewsMyWork | null) {

        if (!model) return

        this.models.push(model)
        this.byId[model.companyId] = model
    }

    // Creates the model on demand - companies added after the last reset (e.g. a
    // freshly created organization) or settings re-parsed from json may have none.
    get(companyId: ID): UserSettingsViewsMyWork {
        if (
            !this.byId[companyId]
            && companyId
        ) {
            this.addForCompany(companyId)
        }

        return this.byId[companyId]
    }

    // Adds a model for every company that has none. Called on companies reset,
    // so models exist for companies loaded/added after settings were parsed.
    syncCompanies() {
        _.map(gd.session.companies.ids, (companyId: ID)=> {

            if (this.byId[companyId]) return

            this.addForCompany(companyId)
        })
    }

    protected addForCompany(companyId: ID) {
        this.add(new UserSettingsViewsMyWork({
            companyId   : companyId,
            ...this.defaults
        }))
    }

    toJson() {

        // return {}

        return _.map(this.models, (model)=> model.toJson())
    }

}
